/**
 * Déclenche le téléchargement d'un PDF renvoyé par le serveur.
 *
 * Le motif est celui du reste du projet (reçus, listes d'élèves) : la réponse
 * est convertie en blob, un lien invisible est cliqué, puis nettoyé. Le
 * `setTimeout` laisse au navigateur le temps d'amorcer le téléchargement avant
 * que l'URL objet ne soit révoquée — la révoquer aussitôt annule le transfert
 * sur certains navigateurs.
 *
 * `reponse` est la réponse `fetch` brute, pas un JSON : un export renvoie un
 * corps binaire.
 */
export const telechargerPdf = async (reponse, nomParDefaut = 'document.pdf') => {
  if (!reponse?.ok) {
    // Le serveur bascule en JSON quand il refuse : on récupère son message.
    let message = "L'export a échoué";
    try {
      const erreur = await reponse.json();
      message = erreur?.message || message;
    } catch {
      // Corps illisible : le libellé par défaut fera l'affaire.
    }
    throw new Error(message);
  }

  const blob = await reponse.blob();
  if (!blob || blob.size === 0) {
    throw new Error('Le fichier reçu est vide');
  }

  // Le nom proposé par le serveur prime : il porte la portée et la date.
  const entete = reponse.headers.get('Content-Disposition') || '';
  const trouve = entete.match(/filename="?([^"]+)"?/);
  const nomFichier = trouve ? trouve[1] : nomParDefaut;

  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nomFichier;
  document.body.appendChild(lien);
  lien.click();

  setTimeout(() => {
    document.body.removeChild(lien);
    window.URL.revokeObjectURL(url);
  }, 100);

  return nomFichier;
};

export default telechargerPdf;
